import React, { act, useEffect, useMemo, useState } from "react";
import $ from "jquery";
import "datatables.net-dt/js/dataTables.dataTables.js";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link } from "react-router-dom";
import toast from "react-hot-toast";
import {
  addCancelHoldApi,
  addReviewOrderAmountApi,
  deleteCategoryApi,
  deleteEmailTemplate,
  deletePackageApi,
  deleteShippingApi,
  exportShipmentOrdersApi,
  getCategoriesApi,
  getEmailTemplate,
  getPackageEnquiryApi,
  getPackageSizeApi,
  getShipmentOrdersApi,
  getShippingChargeApi,
  handleDifferenceApi,
  refundAmountApi,
  resendReviewOrderAmountApi,
  sendMailUserApi,
  updateBulkOrderStatusApi,
  updateOrderStatusApi,
} from "../../apiHelper/authService";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import {
  setSelectedCategory,
  setSelectedEmailTemplate,
  setSelectedFollowUp,
  setSelectedPackage,
  setSelectedShippingCharge,
} from "../../redux/authModalSlice";
const OrderManagementV2 = () => {
  const [activeTab, setActiveTab] = useState("REVIEW");
  const [emailTemplates, setEmailTemplates] = useState();
  const [emailId, setEmailId] = useState("");
  const [sendingEmail, setSendingEmail] = useState(false);
  const [orderLoading, setOrderLoading] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState("");
  const [sendEmailTemplateForm, setSendEmailTemplateForm] = useState({
    subject: "",
    email_template_id: "",
    message: "",
  });
  const tabOptions = [
    { label: "REVIEW", value: "REVIEW" },
    { label: "PLACED", value: "PLACED" },
    { label: "RECEIVED", value: "RECEIVED" },
    { label: "SHIPPED", value: "SHIPPED" },
    { label: "REACHED TO LOCAL PARTNER", value: "REACHED_TO_LOCAL_PARTNER" },
    { label: "DELIVERED", value: "DELIVERED" },
    { label: "HOLD", value: "HOLD" },
    { label: "CANCELLED", value: "CANCELLED" },
    { label: "REFUND", value: "REFUND" },
  ];

  const bulTabOptions = [
    { label: "PLACED", value: "PLACED" },
    { label: "RECEIVED", value: "RECEIVED" },
    { label: "SHIPPED", value: "SHIPPED" },
    { label: "REACHED TO LOCAL PARTNER", value: "REACHED_TO_LOCAL_PARTNER" },
    { label: "DELIVERED", value: "DELIVERED" },
    // { label: "HOLD", value: "HOLD" },
    // { label: "CANCELLED", value: "CANCELLED" },
  ];

  const [reasonMessage, setReasonMessage] = useState("");

  const [remarkMessage, setRemarkMessage] = useState("");
  const [additionalAmmount, setAdditionalAmmount] = useState();

  const [selectedOrders, setSelectedOrders] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [selectedShippingId, setSelectedShippingId] = useState(null);
  const navigate = useNavigate();

  const dispatch = useDispatch();

  const [itemsPerPage] = useState(10);

  const { user } = useSelector((state) => state.authModal);
  // const [categories, setCategories] = useState();
  // const [shippingCharges, setShippingCharges] = useState();
  const [enquiryData, setEnquiryData] = useState([]);

  const fromCountry = user?.from;
  const toCountry = user?.to;

  // console.log("UserData:", fromCountry)

  const [loading, setLoading] = useState(false);

  const [pendingStatusChange, setPendingStatusChange] = useState({
    status: "",
    orderId: "",
  });

  const getEmailTemplates = async () => {
    setLoading(true);

    // const toastId = toast.loading("Fetching Email Templates...");

    try {
      const data = await getEmailTemplate();
      // setCategories(data);
      setEmailTemplates(data?.emailTemplates);
      // toast.success("Email Templates fetched successfully!", { id: toastId });
    } catch (err) {
      console.error("Fetch Error:", err);

      // toast.error(
      //     err?.message || "Something went wrong while fetching email templates.",
      //     { id: toastId }
      // );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getEmailTemplates();
  }, []);

  const handleStatusChange = (selectedStatus, orderId) => {
    if (selectedStatus === "HOLD" || selectedStatus === "CANCELLED") {
      // Save status & orderId for modal submit
      setPendingStatusChange({ status: selectedStatus, orderId });
      return;
    }

    updateOrderStatus(orderId, selectedStatus);
  };

  const manageDifference = async (e) => {
    e.preventDefault(); // Prevent form from submitting the default way

    try {
      await handleDifferenceApi({
        difference_amount: Number(additionalAmmount),
        difference_remarks: remarkMessage,
        shipment_order_id: selectedOrderId,
      });
      await updateOrderStatus(selectedOrderId, "HOLD");
      await getPackageEnquiry();
      setSelectedOrderId("");
      const modalEl = document.getElementById("handleDifference");
      const modalBackdrop = document.querySelector(".modal-backdrop");

      modalEl.classList.remove("show");
      modalEl.style.display = "none";
      modalEl.setAttribute("aria-hidden", "true");

      if (modalBackdrop) modalBackdrop.remove();
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    } catch (err) {
      console.error("Fetch Error:", err);
      toast.error(err?.message || "Something went wrong");
    }
  };

  const updateOrderStatus = async (orderId, selectedStatus) => {
    setLoading(true);
    const toastId = toast.loading("Updating Order Status...");

    try {
      await updateOrderStatusApi(orderId, { status: selectedStatus });
      getPackageEnquiry();
      toast.success("Status Updated", { id: toastId });
    } catch (err) {
      console.error("Fetch Error:", err);
      toast.error(err?.message || "Something went wrong", { id: toastId });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmitReason = async (e) => {
    e.preventDefault();
    if (!reasonMessage.trim()) return;

    const toastId = toast.loading("Submitting Reason...");
    try {
      await addCancelHoldApi({
        id: pendingStatusChange.orderId,
        reason: reasonMessage,
      });

      toast.success("Reason Submitted", { id: toastId });

      // Now update the status
      await updateOrderStatus(
        pendingStatusChange.orderId,
        pendingStatusChange.status
      );

      // Close modal
      setReasonMessage("");
      setPendingStatusChange({ status: "", orderId: "" });
      // const modal = bootstrap.Modal.getInstance(document.getElementById('HoldCancel'));
      // modal?.hide();

      const modalEl = document.getElementById("HoldCancel");
      const modalBackdrop = document.querySelector(".modal-backdrop");

      modalEl.classList.remove("show");
      modalEl.style.display = "none";
      modalEl.setAttribute("aria-hidden", "true");

      if (modalBackdrop) modalBackdrop.remove();
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    } catch (err) {
      console.error("Reason Submit Error:", err);
      toast.error(err?.message || "Failed to submit reason", { id: toastId });
    }
  };

  const handleReasonSubmission = async () => {
    const toastId = toast.loading("Submittion Reason...");

    try {
      const data = await addCancelHoldApi({ reason: reasonMessage });

      toast.success("Reason Submitted", { id: toastId });
    } catch (err) {
      console.error("Fetch Error:", err);

      toast.error(err?.message || "Something went wrong ", { id: toastId });
    }
  };

  const handleBulkStatusChange = async (selectedStatus, orderId) => {
    setLoading(true);

    const toastId = toast.loading("Updating Bulk Status...");

    try {
      const data = await updateBulkOrderStatusApi({
        status: selectedStatus,
        orders: orderId,
      });
      // setCategories(data);
      // setShippingCharges(data)
      // setEnquiryData(data)
      getPackageEnquiry();

      toast.success("Status Updated", { id: toastId });
      // selectedOrders()
    } catch (err) {
      console.error("Fetch Error:", err);

      toast.error(err?.message || "Something went wrong ", { id: toastId });
    } finally {
      setLoading(false);
      setSelectedOrders([]);
      setSelectAll(false);
    }
  };

  const stripHtmlTags = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;
    return div.textContent || div.innerText || "";
  };

  const exportAllOrders = async () => {
    // setLoading(true);

    const toastId = toast.loading("Exporting....");

    try {
      const data = await exportShipmentOrdersApi();

      toast.success("Exported Sucessfully", { id: toastId });

      const ws = XLSX.utils.json_to_sheet(data);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "ShipmentOrders");
      const excelBinaryString = XLSX.write(wb, {
        bookType: "xlsx",
        type: "binary",
      });
      const excelBlob = new Blob([s2ab(excelBinaryString)], {
        ype: "application/octet-stream",
      });
      saveAs(excelBlob, getCurrentTimestampFilename("xlsx"));
    } catch (err) {
      console.error("Fetch Error:", err);

      toast.error(err || "Something went wrong ", { id: toastId });
    } finally {
    }
  };

  function getCurrentTimestampFilename(extension) {
    const currentDate = new Date();
    const dd = String(currentDate.getDate()).padStart(2, "0");
    const mm = String(currentDate.getMonth() + 1).padStart(2, "0");
    const yy = String(currentDate.getFullYear()).slice(-2);
    const hh = String(currentDate.getHours()).padStart(2, "0");
    const min = String(currentDate.getMinutes()).padStart(2, "0");
    const ss = String(currentDate.getSeconds()).padStart(2, "0");
    const timestamp = `${dd}${mm}${yy}${hh}${min}${ss}`;
    return `Orders${timestamp}.${extension}`;
  }

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const getPackageEnquiry = async () => {
    setLoading(true);
    setOrderLoading(true);
    // const toastId = toast.loading("Fetching Email Templates...");
    let page = currentPage;
    let limit = itemsPerPage;
    try {
      const data = await getShipmentOrdersApi({
        status: activeTab,
        page: page,
        limit: limit,
      });
      // setCategories(data);
      // setShippingCharges(data)
      setEnquiryData(data || []);
      setOrderLoading(false);
      // toast.success("Email Templates fetched successfully!", { id: toastId });
    } catch (err) {
      console.error("Fetch Error:", err);

      // toast.error(
      //     err?.message || "Something went wrong while fetching email templates.",
      //     { id: toastId }
      // );
    } finally {
      setLoading(false);
      setOrderLoading(false);
    }
  };

  useEffect(() => {
    getPackageEnquiry();
  }, [activeTab]);

  console.log(enquiryData);

  const [searchQuery, setSearchQuery] = useState("");

  const filteredData = enquiryData?.filter((item) =>
    Object.values(item)?.some((val) =>
      String(val)?.toLowerCase()?.includes(searchQuery?.toLowerCase())
    )
  );

  const totalItems = filteredData?.length || 0;
  const itemsPerPageSafe = itemsPerPage || 1;
  const totalPages = Math.ceil(totalItems / itemsPerPageSafe);
  const startIdx = (currentPage - 1) * itemsPerPage;
  // const currentItems = enquiryData?.slice(startIdx, startIdx + itemsPerPage);
  const currentItems = Array.isArray(filteredData)
    ? filteredData.slice(startIdx, startIdx + itemsPerPage)
    : [];

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  const handleConfirmDelete = async () => {
    if (!selectedShippingId) return;

    setLoading(true);

    const toastId = toast.loading("Deleting...");

    try {
      const data = await deleteShippingApi(selectedShippingId);

      toast.success("Deleted", { id: toastId });
      const modalEl = document.getElementById("exampleModalEdit");
      const modalBackdrop = document.querySelector(".modal-backdrop");

      modalEl.classList.remove("show");
      modalEl.style.display = "none";
      modalEl.setAttribute("aria-hidden", "true");

      if (modalBackdrop) modalBackdrop.remove();
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    } catch (err) {
      console.error("Fetch Error:", err);

      toast.error(
        err?.message || "Something went wrong while fetching categories.",
        { id: toastId }
      );
    } finally {
      setLoading(false);
      // setSelectedCategoryId(null)
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedOrders([]);
    } else {
      setSelectedOrders(enquiryData.map((order) => order.id));
    }
    setSelectAll(!selectAll);
  };

  const handleSelectOne = (id) => {
    const newSelected = selectedOrders.includes(id)
      ? selectedOrders.filter((orderId) => orderId !== id)
      : [...selectedOrders, id];

    setSelectedOrders(newSelected);

    // Automatically handle the selectAll checkbox
    if (newSelected.length === enquiryData.length) {
      setSelectAll(true);
    } else {
      setSelectAll(false);
    }
  };

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const testItems =
    currentItems.length === 1
      ? Array(10).fill(currentItems[0]) // Repeat the same item 10 times
      : currentItems;

  console.log(selectedOrders);

  const formatPickupDateTime = (dateString, timeString) => {
    if (!dateString || !timeString) return "Invalid Date";

    let dateTime;

    // Try ISO format first (YYYY-MM-DD + HH:mm)
    const isoDatePattern = /^\d{4}-\d{2}-\d{2}$/;
    const time24Pattern = /^\d{2}:\d{2}$/;

    try {
      if (isoDatePattern.test(dateString) && time24Pattern.test(timeString)) {
        // Format: YYYY-MM-DD + HH:mm
        dateTime = new Date(`${dateString}T${timeString}`);
      } else {
        // Assume: DD-MM-YYYY + h:mm AM/PM
        const [day, month, year] = dateString.split("-").map(Number);
        const timeParts = timeString.match(/(\d+):(\d+)\s*(AM|PM)/i);

        if (!timeParts) return "Invalid Date";

        let hours = parseInt(timeParts[1]);
        const minutes = parseInt(timeParts[2]);
        const period = timeParts[3].toUpperCase();

        if (period === "PM" && hours !== 12) {
          hours += 12;
        }
        if (period === "AM" && hours === 12) {
          hours = 0;
        }

        dateTime = new Date(year, month - 1, day, hours, minutes);
      }

      if (isNaN(dateTime.getTime())) return "Invalid Date";

      // Final formatting
      const formattedDate = dateTime.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });

      const formattedTime = dateTime.toLocaleTimeString("en-IN", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      });

      return `${formattedDate} at ${formattedTime}`;
    } catch (err) {
      return "Invalid Date";
    }
  };

  console.log(emailId);

  const handleSendMail = async (payload = {}) => {
    setSendingEmail(true);

    try {
      await sendMailUserApi({
        ...payload,
        email: emailId,
        subject: selectedTemplate?.subject,
        message: selectedTemplate?.message,
      });

      // setActiveStatus(status);
      toast.success("Mail has been send to user.");
    } catch (err) {
      // console.error("Error:", err);
      toast.error(err);
    } finally {
      setSendingEmail(false);
    }
  };

  const selectedTemplate = emailTemplates?.find(
    (template) => template.id === sendEmailTemplateForm.email_template_id
  );

  console.log("Selected template:", selectedTemplate);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getValueByKeyPath = (obj, keyPath) => {
    return keyPath.split(".").reduce((acc, key) => acc?.[key], obj) ?? "";
  };

  const sortedItems = useMemo(() => {
    if (!sortConfig.key) return currentItems;

    return [...currentItems].sort((a, b) => {
      let valA = getValueByKeyPath(a, sortConfig.key);
      let valB = getValueByKeyPath(b, sortConfig.key);

      const isNumberLike = (val) =>
        typeof val === "number" ||
        (typeof val === "string" && /^[\d.,$]+$/.test(val.trim()));

      if (isNumberLike(valA) && isNumberLike(valB)) {
        const parseNumericValue = (val) =>
          typeof val === "number"
            ? val
            : parseFloat(val.replace(/[^0-9.-]+/g, "")) || 0;

        valA = parseNumericValue(valA);
        valB = parseNumericValue(valB);
      } else {
        valA = valA?.toString().toLowerCase() || "";
        valB = valB?.toString().toLowerCase() || "";
      }

      if (valA < valB) return sortConfig.direction === "asc" ? -1 : 1;
      if (valA > valB) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [currentItems, sortConfig]);

  const getSortIcon = (key) => {
    const baseClass = "transition-all duration-300 ease-in-out";

    if (sortConfig.key !== key) {
      // Neutral icon when column is not sorted
      return (
        <Icon
          icon="lucide:chevrons-up-down"
          className={`${baseClass} text-muted`}
        />
      );
    }

    return sortConfig.direction === "asc" ? (
      <Icon icon="lucide:chevron-up" className={`${baseClass} text-muted`} />
    ) : (
      <Icon icon="lucide:chevron-down" className={`${baseClass} text-muted`} />
    );
  };
  const [selectedRefundOrder, setSelectedRefundOrder] = useState();
  const [refundAmount, setRefundAmount] = useState();
  const [refundRemarks, setRefundRemarks] = useState();
  const handleRefundClick = async (selectedOrder) => {
    setSelectedRefundOrder(selectedOrder);
    console.log("Selected Order ::", selectedOrder);
    // const modalEl = document.getElementById("refundModel");
    // const modalBackdrop = document.querySelector(".modal-backdrop");

    // modalEl.classList.remove("show");
    // modalEl.style.display = "none";
    // modalEl.setAttribute("aria-hidden", "true");

    // if (modalBackdrop) modalBackdrop.remove();
    // document.body.classList.remove("modal-open");
    // document.body.style.overflow = "";
    // document.body.style.paddingRight = "";
  };
  console.log("SELECTED REFUND ORDER ::", selectedRefundOrder);
  console.log("REFUND AMOUNT ::", refundAmount);

  const handleRefundSubmitClick = async () => {
    try {
      if (!refundAmount) return toast.error("Refund Amount is required");
      if (!refundRemarks) return toast.error("Refund Remarks is required");
      if (!selectedRefundOrder)
        return toast.error("Please select Refund Order");
      console.log("REfund Order", selectedRefundOrder);
      if (parseInt(refundAmount) > selectedRefundOrder.grandTotal)
        return toast.error(
          "Refund Amount should not be greater then order amount"
        );
      let response = await refundAmountApi({
        order_id: selectedRefundOrder?.id,
        amount: refundAmount,
        refund_reason: refundRemarks,
      });
      if (response) {
        toast.success("Amount Refunded!");

        const modalEl = document.getElementById("refundModel");
        const modalBackdrop = document.querySelector(".modal-backdrop");

        modalEl.classList.remove("show");
        modalEl.style.display = "none";
        modalEl.setAttribute("aria-hidden", "true");

        if (modalBackdrop) modalBackdrop.remove();
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";
        getPackageEnquiry();
        setSelectedRefundOrder();
        setRefundAmount();
        setRefundRemarks();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const generatePagination = (currentPage, totalPages) => {
    const delta = 2; // neighbors count
    const range = [];

    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      range.push(i);
    }

    if (range[0] > 2) {
      range.unshift("...");
    }
    if (range[0] !== 1) {
      range.unshift(1);
    }

    if (range[range.length - 1] < totalPages - 1) {
      range.push("...");
    }
    if (range[range.length - 1] !== totalPages) {
      range.push(totalPages);
    }

    return range;
  };
  const [selectedReviewOrder, setSelectedReviewOrder] = useState();
  const [reviewAmount, setReviewAmount] = useState();
  const [reviewRemark, setReviewRemark] = useState("");
  const [editedAmount, setEditedAmount] = useState(0);
  const [subTotal, setSubTotal] = useState(0);
  const handleAddAmountReviewOrder = (selectedOrder) => {
    try {
      console.log("Selected Orders ::", selectedOrder);
      setReviewAmount(selectedOrder?.subTotal);
      setReviewRemark(selectedOrder?.reviewRemarks);
      setSelectedReviewOrder(selectedOrder);
     
    } catch (error) {
      console.log(error);
    }
  };
  

  const handleReviewAmountAddClick = async () => {
    if (!reviewAmount && !editedAmount) {
      toast.error("Please enter an amount.");
      return;
    }

    if (!reviewRemark) {
      toast.error("Please enter a remark.");
      return;
    }
    if(!selectedReviewOrder){
      toast.error("Please select an order")  
      return
    }
    // setLoading(true);

    const toastId = toast.loading("Submitting...");

    try {
      const payload = {
        orderId: selectedReviewOrder?.id,
        amount: reviewAmount ? reviewAmount : parseFloat(subTotal) + parseFloat(editedAmount),
        remarks: reviewRemark,
      };
      const res = await addReviewOrderAmountApi(payload);
      setReviewAmount("");
      setReviewRemark("");
      getPackageEnquiry();
      getPackageEnquiry();

      toast.success("Submitted Sucessfully", { id: toastId });
      const modalEl = document.getElementById("resendOrder");
      const modalBackdrop = document.querySelector(".modal-backdrop");

      modalEl.classList.remove("show");
      modalEl.style.display = "none";
      modalEl.setAttribute("aria-hidden", "true");

      if (modalBackdrop) modalBackdrop.remove();
      document.body.classList.remove("modal-open");
      document.body.style.overflow = "";
      document.body.style.paddingRight = "";
    } catch (err) {
      console.error("Fetch Error:", err);

      toast.error(err || "Something went wrong.", { id: toastId });
    } finally {
      setLoading(false);
      // setSelectedCategoryId(null)
    }
  };
  const [selectedResendOrder, setSelectedResendOrder] = useState();
  const handleResendAmount = async (selectedOrder) => {
    try {
      console.log("SELECTED RESEND ORDER ::",selectedOrder);
      
      setSelectedResendOrder(selectedOrder);
      setSelectedReviewOrder(selectedOrder);

      console.log("RESEND SELECTED ORORDER", selectedOrder);
      // const modalEl = document.getElementById("resendReviewOrder");
      // const modalBackdrop = document.querySelector(".modal-backdrop");

      // modalEl.classList.remove("show");
      // modalEl.style.display = "none";
      // modalEl.setAttribute("aria-hidden", "true");

      // if (modalBackdrop) modalBackdrop.remove();
      // document.body.classList.remove("modal-open");
      // document.body.style.overflow = "";
      // document.body.style.paddingRight = "";
    } catch (error) {
      console.log(error);
    }
  };

  // const handeResendAmountClick = async () => {
  //   try {
  //     console.log("Selected Resend Order ::", selectedResendOrder);
  //     let payload = {
  //       orderId: selectedResendOrder.id,
  //     };
  //     let res = await resendReviewOrderAmountApi(payload);
  //     console.log(res);
  //     toast.success("Send Sucessfully");
  //     const modalEl = document.getElementById("resendReviewOrder");
  //     const modalBackdrop = document.querySelector(".modal-backdrop");

  //     modalEl.classList.remove("show");
  //     modalEl.style.display = "none";
  //     modalEl.setAttribute("aria-hidden", "true");

  //     if (modalBackdrop) modalBackdrop.remove();
  //     document.body.classList.remove("modal-open");
  //     document.body.style.overflow = "";
  //     document.body.style.paddingRight = "";
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };


  const handeResendAmountClick = async () => {
  const toastId = toast.loading("Sending...");

  try {
    console.log("Selected Resend Order ::", selectedResendOrder);
    const payload = {
      orderId: selectedResendOrder.id,
    };

    const res = await resendReviewOrderAmountApi(payload);
    console.log(res);

    toast.success("Sent Successfully", { id: toastId });

    // Close modal
    const modalEl = document.getElementById("resendReviewOrder");
    const modalBackdrop = document.querySelector(".modal-backdrop");

    modalEl.classList.remove("show");
    modalEl.style.display = "none";
    modalEl.setAttribute("aria-hidden", "true");

    if (modalBackdrop) modalBackdrop.remove();
    document.body.classList.remove("modal-open");
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

  } catch (error) {
    console.error(error);
    toast.error("Something went wrong", { id: toastId });
  }
};

  
  const handleResendAmountReviewOrderClick = (selectedOrder)=>{
    console.log("Selected Order ::",selectedOrder);
    setSubTotal(selectedOrder.subTotal)
    setSelectedReviewOrder(selectedOrder)
    

  }
  return (
    <>
      <div className="card basic-data-table">
        <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3">
            <form className="navbar-search">
              <input
                type="text"
                className="bg-base h-40-px w-auto"
                name="search"
                placeholder="Search"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <Icon icon="ion:search-outline" className="icon" />
            </form>

            {selectedOrders?.length >= 1 && activeTab !== "DELIVERED" && (
             <div className="dropdown d-flex justify-content-center">
  <button
    className="btn text-primary-600 bg-primary-light border border-primary-light-white px-18 py-8 d-flex align-items-center justify-content-center gap-2"
    type="button"
    data-bs-toggle="dropdown"
    aria-expanded="false"
    title="Update Status"
  >
    Update Bulk Status
    <Icon icon="mdi:chevron-down" className="text-primary-600" />
  </button>

  <ul className="dropdown-menu">
    {bulTabOptions
      .filter((option) => {
        // Show all options if current status is HOLD or CANCELLED
        if (activeTab === "HOLD" || activeTab === "CANCELLED") {
          return option.value !== activeTab; // exclude current status itself
        }

        // Otherwise only show statuses *after* current status (forward progression)
        const currentIndex = bulTabOptions.findIndex(
          (opt) => opt.value === activeTab
        );
        const optionIndex = bulTabOptions.findIndex(
          (opt) => opt.value === option.value
        );

        // optionIndex must be greater than currentIndex to exclude current and previous statuses
        return optionIndex > currentIndex;
      })
      .map((option) => (
        <li key={option.value}>
          <Link
            className="dropdown-item px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900"
            onClick={() =>
              handleBulkStatusChange(option.value, selectedOrders)
            }
          >
            {option.label}
          </Link>
        </li>
      ))}
  </ul>
</div>
            )}
          </div>
          <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
            <div className="position-relative" style={{ minWidth: "180px" }}>
              <Icon
                icon="solar:alt-arrow-down-outline"
                className="position-absolute"
                style={{
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  pointerEvents: "none",
                  color: "#6c757d",
                  zIndex: 1,
                }}
              />

              <select
                className="custom-select-no-arrow form-select form-select-sm pe-5 ps-3 rounded border"
                style={{
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                }}
                value={activeTab}
                onChange={(e) => {
                  setSelectAll(false);
                  setActiveTab(e.target.value);
                  setSelectedOrders([]);
                }}
              >
                {tabOptions.map((tab) => (
                  <option key={tab.value} value={tab.value}>
                    {tab.label}
                  </option>
                ))}
              </select>
            </div>

            <Link
              to={"/add-order"}
              className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
            >
              <Icon
                icon="ic:baseline-plus"
                className="icon text-xl line-height-1"
              />
              Add New Order
            </Link>

            {filteredData?.length > 0 && (
              <Link
                onClick={() => exportAllOrders()}
                className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
              >
                <Icon
                  icon="mdi:export-variant"
                  className="icon text-xl line-height-1"
                />
                Export Orders
              </Link>
            )}
          </div>
        </div>

        <div className="card-body">
          <div className="table-responsive" style={{ minHeight: "50vh" }}>
            <table className="table vertical-striped-table mb-0">
              <thead>
                <tr>
                  <th scope="col">
                    {" "}
                    <div className="form-check style-check d-flex align-items-center">
                      <input
                        className="form-check-input"
                        type="checkbox"
                        defaultValue=""
                        id="checkAll"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                    </div>
                  </th>

                  {/* <th scope="col">Date</th> */}
                  {/* <th scope="col">    Order ID</th> */}

                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSort("display_id")}
                    scope="col"
                  >
                    <div className="d-flex align-items-center gap-2">
                      Order ID 
                      {/* {getSortIcon("display_id")} */}
                    </div>
                  </th>
                  {/* <th scope="col">    Order Date</th> */}

                  <th  style={{ cursor: "pointer" }} scope="col"
                  onClick={()=> handleSort("createdAt")}
                  >
                    <div className="d-flex align-items-center gap-2">
                      Order Date {getSortIcon("createdAt")}
                    </div>
                  </th>

                  {/* <th scope="col">        Human Resource Charge</th> */}
                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSort("user.fullname")}
                    scope="col"
                  >
                    {" "}
                    <div className="d-flex align-items-center gap-2">
                      Full Name 
                      {/* {getSortIcon("user.fullname")} */}
                    </div>
                  </th>

                  {/* <th scope="col">        User Mobile </th> */}

                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSort("mobile_number")}
                    scope="col"
                  >
                    <div className="d-flex align-items-center gap-2">
                    Mobile 
                    {/* {getSortIcon("mobile_number")} */}
                    </div>
                  </th>

                  <th
                    style={{ cursor: "pointer" }}
                    onClick={() => handleSort("user.email")}
                    scope="col"
                  >
                    <div className="d-flex align-items-center gap-2">
                    Email 
                    {/* {getSortIcon("user.email")} */}
                    </div>
                  </th>

                  {/* <th scope="col">                User Email</th> */}

                  {/* <th scope="col">                Shipment Type   </th> */}

                  <th
                    onClick={() => handleSort("shipment_type")}
                    style={{ cursor: "pointer" }}
                    scope="col"
                  >
                    <div className="d-flex align-items-center gap-2">
                      Shipment Type 
                      {getSortIcon("shipment_type")}
                    </div>
                  </th>

                  <th
                    onClick={() => handleSort("package_size.size_name")}
                    style={{ cursor: "pointer" }}
                    scope="col"
                  >
                    <div className="d-flex align-items-center gap-2">
                      Shipment Size 
                      {/* {getSortIcon("package_size.size_name")} */}
                    </div>
                  </th>

                  {/* <th scope="col">                Shipment Size</th> */}
                  {/* <th scope="col">                Order Type </th> */}

                  <th
                    onClick={() => handleSort("pickup_type")}
                    style={{ cursor: "pointer" }}
                    scope="col"
                  >
                    <div className="d-flex align-items-center gap-2">
                      Order Type 
                      {/* {getSortIcon("pickup_type")} */}
                    </div>
                  </th>
                  {/* <th scope="col">                Order Date/Time </th> */}

                  <th style={{ cursor: "pointer" }} scope="col" >
                    <div className="d-flex align-items-center gap-2">
                      Pickup/Drop Date-Time
                    </div>
                  </th>

                  {/* <th scope="col">            Insurance</th> */}
                  {/* <th scope="col">            Insurance value</th> */}

                  {/* <th
                    onClick={() => handleSort("insuranceCharges")}
                    style={{ cursor: "pointer" }}
                    scope="col"
                  >
                    <div className="d-flex align-items-center gap-2">
                      Insurance value {getSortIcon("insuranceCharges")}
                    </div>
                  </th> */}
                  {/* <th scope="col">            Order Amount</th> */}
                  {activeTab === "REVIEW" && <th>Add Amount</th>}
                  {activeTab !== "REVIEW" && (
                    <th
                      onClick={() => handleSort("grandTotal")}
                      style={{ cursor: "pointer" }}
                      scope="col"
                    >
                      <div className="d-flex align-items-center gap-2">
                        Order Amount {getSortIcon("grandTotal")}
                      </div>
                    </th>
                  )}
                  {activeTab === "REFUND" && <th scope="col">Action</th>}
                  {activeTab === "REFUND" && <th scope="col">Refund Reason</th>}
                  {/* <th scope="col">            Order Details</th> */}
                  {activeTab !== "REFUND" && activeTab !== "REVIEW" && (
                    <>
                      <th scope="col"> Handle Difference</th>
                      <th scope="col"> Send Email</th>
                    </>
                  )}

                  {activeTab !== "DELIVERED" &&
                    activeTab !== "REFUND" &&
                    activeTab !== "REVIEW" && (
                      <th scope="col"> Update Status</th>
                    )}

                  {/* 
                                    {activeTab !== "CLOSED" &&

                                        <th scope="col">Action</th>} */}
                </tr>
              </thead>
              <tbody>
                {orderLoading ? (
                  <tr>
                    <td colSpan="15" className="text-center py-20">
                      <div
                        className="spinner-border"
                        role="status"
                        style={{
                          color: "#243E85",
                          width: "2rem",
                          height: "2rem",
                          borderWidth: "0.3em",
                        }}
                      >
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : currentItems?.length > 0 ? (
                  sortedItems?.map((shipOrder) => (
                    <tr key={shipOrder.id}>
                      <td>
                        <div className="form-check style-check d-flex align-items-center">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            defaultValue=""
                            id="check1"
                            checked={selectedOrders.includes(shipOrder.id)}
                            onChange={() => handleSelectOne(shipOrder.id)}
                          />
                        </div>
                      </td>

                      <td>
                        <h6 className="text-md mb-0 fw-normal">
                          {" "}
                          #{shipOrder?.display_id}
                        </h6>
                      </td>

                      <td>
                        <span className="text-sm text-secondary-light fw-normal">
                          {formatDate(shipOrder.createdAt)}
                        </span>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {shipOrder?.user?.fullname}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {/* {shipOrder.mobile_number} */}{" "}
                            {shipOrder?.mobile_number
                              ? shipOrder?.mobile_number
                              : "-"}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {shipOrder?.user?.email}
                          </h6>
                        </div>
                      </td>

                      <td>
                        <span
                          className={`${
                            shipOrder?.shipment_type === "AIR"
                              ? "bg-success-focus text-success-main"
                              : "bg-warning-focus text-warning-main"
                          } px-24 py-4 rounded-pill fw-medium text-sm d-flex align-items-center gap-2 justify-content-center`}
                        >
                          {shipOrder?.shipment_type === "AIR" ? (
                            <>
                              <Icon
                                icon="mdi:airplane"
                                width="16"
                                height="16"
                              />
                              Air
                            </>
                          ) : (
                            <>
                              <Icon icon="mdi:ferry" width="16" height="16" />
                              Ship
                            </>
                          )}
                        </span>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            {/* {shipOrder?.user?.email} */}{" "}
                            {shipOrder?.package_size?.size_name
                              ? shipOrder?.package_size?.size_name
                              : "Custom"}
                          </h6>
                        </div>
                      </td>

                      <td>
                        {shipOrder?.pickup_type ? (
                          <>
                            <h6 className="text-md mb-0 fw-normal">
                              {" "}
                              {shipOrder?.pickup_type}
                            </h6>
                          </>
                        ) : (
                          "-"
                        )}
                      </td>

                      <td>
                        <span className="text-sm text-secondary-light fw-normal">
                          {formatPickupDateTime(
                            shipOrder?.pickup_date,
                            shipOrder?.pickup_time
                          )}{" "}
                        </span>
                      </td>

                      {/* <td className="text-end">
                        <div className="d-flex justify-content-end w-100 align-items-center">
                          <h6 className="text-md mb-0 fw-medium flex-grow-1 ">
                            $
                            {!shipOrder?.insuranceCharges > 0
                              ? "0"
                              : shipOrder?.insuranceCharges.toFixed(2)}
                          </h6>
                        </div>
                      </td> */}
                      {activeTab === "REVIEW" && (
                        // console.log("REVUEW DWDWIjh",shipOrder)

                        <th>
                          <div style={{ display: "flex" }}>
                            {/* <Link
                              onClick={() =>
                                handleAddAmountReviewOrder(shipOrder)
                              }
                              className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                              data-bs-toggle="modal"
                              data-bs-target="#reviewOrder"
                              disabled={shipOrder.isReviewDone === true}
                            >
                              <Icon icon="lucide:send" />
                            </Link> */}
                            <button
                              onClick={() =>
                                handleAddAmountReviewOrder(shipOrder)
                              }
                              disabled={shipOrder.isReviewDone === true}
                              data-bs-toggle="modal"
                              data-bs-target="#reviewOrder"
                              className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                            >
                              <Icon icon="lucide:send" />
                            </button>
                            <Link
                              onClick={() =>
                                handleResendAmountReviewOrderClick(shipOrder)
                              }
                              data-bs-toggle="modal"
                              data-bs-target="#resendOrder"
                              disabled={shipOrder.isReviewDone === false}
                              className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                            >
                              <Icon icon="lucide:edit" />
                            </Link>
                            <button
                              onClick={() => handleResendAmount(shipOrder)}
                              className="w-32-px h-32-px me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                              data-bs-toggle="modal"
                              data-bs-target="#resendReviewOrder"
                            >
                              <Icon icon="lucide:rotate-ccw" />
                            </button>
                          </div>
                        </th>
                      )}
                      {activeTab !== "REVIEW" && (
                        <td className="text-end">
                          <div className="d-flex justify-content-end align-items-center w-100">
                            <h6 className="text-md mb-0 fw-medium">
                              ${shipOrder?.grandTotal.toFixed(2)}
                            </h6>
                          </div>
                        </td>
                      )}
                      {console.log(shipOrder)}
                      {activeTab === "REFUND" && (
                        <td>
                          <button
                            // onClick={() => exportAllOrders()}
                            disabled={
                              shipOrder.shipment_payment_status ===
                              "PAYMENT_REFUNDED"
                            }
                            onClick={() => handleRefundClick(shipOrder)}
                            className="btn btn-primary text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"
                            data-bs-toggle="modal"
                            data-bs-target="#refundModel"
                          >
                            Refund Amount
                          </button>
                        </td>
                      )}
                      {activeTab === "REFUND" && (
                        <td>
                          <label htmlFor="">
                            {shipOrder?.payment_refund_reason}
                          </label>
                        </td>
                      )}
                      {activeTab !== "REFUND" && activeTab !== "REVIEW" && (
                        <>
                          <td>
                            <div
                              className="d-flex align-items-center "
                              style={{ justifyContent: "center" }}
                            >
                              <Link
                                // to="#"
                                onClick={() =>
                                  setSelectedOrderId(shipOrder?.id)
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#handleDifference"
                                className="w-32-px h-32-px  me-8 bg-success-focus text-success-main rounded-circle d-inline-flex align-items-center justify-content-center"
                              >
                                <Icon icon="lucide:edit" />
                              </Link>
                            </div>
                          </td>

                          <td>
                            <div
                              className="d-flex align-items-center"
                              style={{ justifyContent: "center" }}
                            >
                              <span
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  setEmailId(shipOrder?.user?.email)
                                }
                                data-bs-toggle="modal"
                                data-bs-target="#sendMail"
                                className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                                title="Send Email"
                              >
                                <Icon icon="lucide:mail" />
                              </span>
                            </div>
                          </td>
                        </>
                      )}

                      {activeTab !== "DELIVERED" &&
                        activeTab !== "REFUND" &&
                        activeTab !== "REVIEW" && (
                          <td>
                            <div className="dropdown d-flex justify-content-center">
                              <button
                                className="btn bg-success-100 border-success-100 text-success-600 px-18 py-11 d-flex align-items-center justify-content-center rounded-circle"
                                type="button"
                                data-bs-toggle="dropdown"
                                aria-expanded="false"
                                title="Update Status"
                              >
                                <Icon icon="lucide:refresh-ccw" />
                              </button>

                              <ul className="dropdown-menu">
                                {tabOptions
                                  .filter((option) => {
                                    // Show all options if current status is HOLD or CANCELLED
                                    if (
                                      shipOrder?.shipment_order_status ===
                                        "HOLD" ||
                                      shipOrder?.shipment_order_status ===
                                        "CANCELLED"
                                    ) {
                                      return (
                                        option.value !==
                                        shipOrder?.shipment_order_status
                                      ); // exclude current status itself
                                    }

                                    // Otherwise only show statuses *after* current status (forward progression)
                                    const currentIndex = tabOptions.findIndex(
                                      (opt) =>
                                        opt.value ===
                                        shipOrder?.shipment_order_status
                                    );
                                    const optionIndex = tabOptions.findIndex(
                                      (opt) => opt.value === option.value
                                    );

                                    // optionIndex must be greater than currentIndex to exclude current and previous statuses
                                    return optionIndex > currentIndex;
                                  })
                                  .map((option) => (
                                    <li key={option.value}>
                                      <Link
                                        className={`dropdown-item  px-16 py-8 rounded text-secondary-light bg-hover-neutral-200 text-hover-neutral-900`}
                                        data-bs-toggle={`${
                                          option?.value === "HOLD" ||
                                          option?.value === "CANCELLED"
                                            ? "modal"
                                            : ""
                                        }`}
                                        // data-bs-target="#exampleModal"

                                        data-bs-target={`${
                                          option?.value === "HOLD" ||
                                          option?.value === "CANCELLED"
                                            ? "#HoldCancel"
                                            : ""
                                        }`}
                                        onClick={() =>
                                          handleStatusChange(
                                            option.value,
                                            shipOrder?.id
                                          )
                                        }
                                      >
                                        {option.label}
                                      </Link>
                                    </li>
                                  ))}
                              </ul>
                            </div>
                          </td>
                        )}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="15" className="text-center py-16 text-muted">
                      No Orders found.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          {filteredData?.length > itemsPerPage && (
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mt-24">
              <span>
                Showing {startIdx + 1} to{" "}
                {Math.min(startIdx + itemsPerPage, filteredData?.length)} of{" "}
                {filteredData?.length} entries
              </span>
              <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                <li className="page-item">
                  <button
                    className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    <Icon icon="ep:d-arrow-left" className="text-xl" />
                  </button>
                </li>

                {/* {[...Array(totalPages)].map((_, index) => (
                  <li className="page-item" key={index}>
                    <button
                      className={`page-link ${
                        currentPage === index + 1
                          ? "bg-primary-600 text-white"
                          : "bg-primary-50 text-secondary-light"
                      } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                      onClick={() => goToPage(index + 1)}
                    >
                      {index + 1}
                    </button>
                  </li>
                ))} */}

                {generatePagination(currentPage, totalPages).map(
                  (page, index) => (
                    <li className="page-item" key={index}>
                      {page === "..." ? (
                        <span className="page-link bg-transparent border-0 text-secondary-light">
                          ...
                        </span>
                      ) : (
                        <button
                          className={`page-link ${
                            currentPage === page
                              ? "bg-primary-600 text-white"
                              : "bg-primary-50 text-secondary-light"
                          } fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px`}
                          onClick={() => goToPage(page)}
                        >
                          {page}
                        </button>
                      )}
                    </li>
                  )
                )}

                <li className="page-item">
                  <button
                    className="page-link text-secondary-light fw-medium radius-4 border-0 px-10 py-10 d-flex align-items-center justify-content-center h-32-px me-8 w-32-px bg-base"
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    <Icon icon="ep:d-arrow-right" className="text-xl" />
                  </button>
                </li>
              </ul>
            </div>
          )}
        </div>
      </div>

      <div
        className="modal fade"
        id="exampleModalEdit"
        tabIndex={-1}
        aria-labelledby="exampleModalEditLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalEditLabel">
                Confirm Deletion
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24 text-center">
              <p className="mb-4 fs-6 text-secondary">
                Are you sure you want to delete this item?
              </p>
              <div className="d-flex justify-content-center gap-3 mt-3">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={handleConfirmDelete}
                >
                  Confirm
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="HoldCancel"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Enter Reason
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form onSubmit={handleSubmitReason}>
                <div className="row">
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Reason For Cancellation/Hold
                    </label>
                    <textarea
                      required
                      className="form-control radius-8"
                      placeholder="Enter Remark for Cancellation/Hold"
                      name="remarkMessage"
                      value={remarkMessage}
                      onChange={(e) => setRemarkMessage(e.target.value)}
                      rows={4}
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="handleDifference"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Manage Difference
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form onSubmit={manageDifference}>
                <div className="row">
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Additional Amount
                    </label>
                    <input
                      required
                      className="form-control radius-8"
                      placeholder="Enter Additional Ammount"
                      name="additionalAmmount"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={additionalAmmount}
                      onChange={(e) => setAdditionalAmmount(e.target.value)}
                    />
                  </div>

                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Remarks (for hold)
                    </label>
                    <textarea
                      required
                      className="form-control radius-8"
                      placeholder="Enter Remarks for Hold"
                      name="remarkMessage"
                      value={remarkMessage}
                      onChange={(e) => setRemarkMessage(e.target.value)}
                      rows={4} // You can adjust the number of rows as needed
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                    >
                      Hold and Send Payment Link
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Send Email Form  */}

      <div
        className="modal fade"
        id="sendMail"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Send mail to user
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form
                onSubmit={async (e) => {
                  e.preventDefault();

                  // Optional validation

                  await handleSendMail({
                    email_template_id: sendEmailTemplateForm?.email_template_id,
                  });

                  setSendEmailTemplateForm({
                    message: "",
                    subject: "",
                    email_template_id: "",
                  });

                  const modalEl = document.getElementById("sendMail");
                  const modalBackdrop =
                    document.querySelector(".modal-backdrop");

                  modalEl.classList.remove("show");
                  modalEl.style.display = "none";
                  modalEl.setAttribute("aria-hidden", "true");

                  if (modalBackdrop) modalBackdrop.remove();
                  document.body.classList.remove("modal-open");
                  document.body.style.overflow = "";
                  document.body.style.paddingRight = "";
                }}
              >
                <div className="row">
                  {/* Remarks Field */}

                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Select Email Template
                    </label>
                    <select
                      required
                      className="form-control radius-8"
                      value={sendEmailTemplateForm.email_template_id}
                      onChange={(e) =>
                        setSendEmailTemplateForm({
                          ...sendEmailTemplateForm,
                          email_template_id: e.target.value,
                        })
                      }
                    >
                      <option value="">-- Select Email Template --</option>
                      {emailTemplates?.map((template) => (
                        <option key={template.id} value={template.id}>
                          {template.title}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Subject
                    </label>
                    <input
                      required
                      className="form-control radius-8"
                      placeholder="subject"
                      value={selectedTemplate?.subject}
                      disabled
                    />
                  </div>

                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Message
                    </label>
                    <textarea
                      required
                      className="form-control radius-8"
                      placeholder="message"
                      value={
                        selectedTemplate
                          ? stripHtmlTags(selectedTemplate.message)
                          : ""
                      }
                      disabled
                      rows={3}
                    />
                  </div>

                  {/* Email Template Select */}

                  {/* Submit Button */}
                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      disabled={sendingEmail}
                      type="submit"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                    >
                      {sendingEmail ? "Sending..." : "Send"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="refundModel"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Refund Amount
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form onSubmit={manageDifference}>
                <div className="row">
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Amount
                    </label>
                    <input
                      required
                      className="form-control radius-8"
                      placeholder="Enter Amount"
                      name="additionalAmmount"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={refundAmount}
                      onChange={(e) => setRefundAmount(e.target.value)}
                    />
                  </div>

                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Refund Reason
                    </label>
                    <textarea
                      required
                      className="form-control radius-8"
                      placeholder="Enter Refund Reason"
                      name="refundRemark"
                      value={refundRemarks}
                      onChange={(e) => setRefundRemarks(e.target.value)}
                      rows={4} // You can adjust the number of rows as needed
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      type="button"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                      onClick={handleRefundSubmitClick}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="reviewOrder"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Review Amount
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form>
                <div className="row">
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Amount
                    </label>
                    <input
                      required
                      className="form-control radius-8"
                      placeholder="Enter Amount"
                      name="additionalAmount"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={reviewAmount}
                      onChange={(e) => setReviewAmount(e.target.value)}
                    />
                  </div>

                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Remarks
                    </label>
                    <textarea
                      required
                      className="form-control radius-8"
                      placeholder="Enter Remarks"
                      name="remarks"
                      rows="4"
                      value={reviewRemark}
                      onChange={(e) => setReviewRemark(e.target.value)}
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      type="button"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                      onClick={handleReviewAmountAddClick}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="resendOrder"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        {/* <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Edit Review Amount
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form>
                <div className="row">
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Amount
                    </label>
                    <input
                      required
                      className="form-control radius-8"
                      placeholder="Enter Amount"
                      name="additionalAmount"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={editedAmount}
                      onChange={(e) => setEditedAmount(e.target.value)}
                    />
                  </div>

                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Remarks
                    </label>
                    <textarea
                      required
                      className="form-control radius-8"
                      placeholder="Enter Remarks"
                      name="remarks"
                      rows="4"
                      value={reviewRemark}
                      onChange={(e) => setReviewRemark(e.target.value)}
                    />
                  </div>

                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      type="button"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                      onClick={handleReviewAmountAddClick}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div> */}
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Edit Review Amount
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={()=>{
                  setEditedAmount(0)
                  setReviewRemark("")
                }}
              />
            </div>
            <div className="modal-body p-24">
              <form>
                <div className="row">
                  {/* Edited Amount */}
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Additional Amount
                    </label>
                    <input
                      required
                      className="form-control radius-8"
                      placeholder="Enter Amount"
                      name="additionalAmount"
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                      value={editedAmount}
                      onChange={(e) => setEditedAmount(e.target.value)}
                    />
                  </div>

                  {/* Subtotal */}
                  <div className="col-12 col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Subtotal
                    </label>
                    <input
                      className="form-control radius-8"
                      value={subTotal}
                      disabled
                    />
                  </div>

                  {/* Total */}
                  <div className="col-12 col-md-6 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Total
                    </label>
                    <input
                      className="form-control radius-8"
                      value={
                        editedAmount
                          ? parseFloat(subTotal || 0) +
                            parseFloat(editedAmount || 0)
                          : subTotal
                      }
                      disabled
                    />
                  </div>

                  {/* Remarks */}
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-sm mb-8">
                      Remarks
                    </label>
                    <textarea
                      required
                      className="form-control radius-8"
                      placeholder="Enter Remarks"
                      name="remarks"
                      rows="4"
                      value={reviewRemark}
                      onChange={(e) => setReviewRemark(e.target.value)}
                    />
                  </div>

                  {/* Submit Button */}
                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      type="button"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                      onClick={handleReviewAmountAddClick}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="resendReviewOrder"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
          <div className="modal-content radius-16 bg-base">
            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Resend Amount
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              />
            </div>
            <div className="modal-body p-24">
              <form>
                <div className="row">
                  <div className="col-12 col-md-12 mb-20">
                    <label className="form-label fw-semibold text-primary-light text-lg mb-8">
                      Do you want to resend ?
                    </label>
                  </div>
                  <div className="d-flex align-items-center justify-content-start gap-3 mt-12">
                    <button
                      type="button"
                      className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                      onClick={handeResendAmountClick}
                    >
                      Yes
                    </button>
                    <button
                      type="button"
                      className="btn btn-secondary border border-secondary-600 text-md px-48 py-12 radius-8"
                      data-bs-dismiss="modal"
                    >
                      No
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderManagementV2;
